import React from 'react';
import _ from 'underscore';
import AbstractRequestTask from '../AbstractRequestTask';

class DataTask extends AbstractRequestTask {
  constructor(config, params) {
    super();

    if (params.cacheable) {
      this.isCacheable = true;
      delete params.cacheable;
    }

    this.config = config;
    this.__params = params;
  }

  getUrl() {
    const domain = this.config.url_dominio_microfwk;
    return `${domain}services/content/data`;
  }

  getParams() {
    const params = super.getParams(this.config);

    const result = _.extend(params, this.__params);

    if (this.isCacheable) {
      delete result.HKS;
    }

    return result;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid || !data.response.group.common) {
      const newError = super.parseErrors(data);
      return this.reject(newError, b);
    }

    const common = data.response.group.common;

    common.isSerie = common.extendedcommon.media.serie != null;
    common.hasPreview = common.extendedcommon.media.haspreview == 'true';

    if (
      common.extendedcommon.format.sell_type.includes('susc') ||
      common.extendedcommon.format.sell_type.includes('free')
    ) {
      common.canPlay = true;
    }

    if (common.isSerie) {
      common.image_background =
        common.extendedcommon.media.serieseason.image_background;
      common.image_large = common.extendedcommon.media.serieseason.image_large;
      common.image_small = common.extendedcommon.media.serieseason.image_small;
      common.image_medium =
        common.extendedcommon.media.serieseason.image_medium;
    }

    common.external = data.response.group.external || {};

    this.resolve(common);
  }
}

export default DataTask;
